import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import * as st from './Beard.module.scss'

import * as cn from 'classnames'

export interface BeardProps extends BaseComponentProps {
  title: React.ReactChild
  secondLine?: React.ReactChild
  thirdLine?: React.ReactChild
  contentBlock?: React.ReactChild,
  actions?: React.ReactChild[]
}

export class Beard extends React.Component<BeardProps> {
  static defaultProps = {
    secondLine: false as boolean,
    thirdLine: false as boolean,
    contentBlock: false as boolean
  }

  // Add displayName to preserve the component name on snapshot testing
  displayName = 'Beard'

  render() {
    const containerClassNames = extractClassNamesFromProps(
      this.props,
      st.beardContainer,
      'dvui-beardContainer'
    )
    const classNames = cn(
      st.beard,
      'mustache',
      {
        [st.twoLines]: Boolean(this.props.secondLine)
      }
    )
    return (
      <div className={containerClassNames}>
        {this.props.children}
        <div className={classNames}>
          <div className={st.lines}>
            <div className={st.firstLine}>
              <span className={st.title}>{this.props.title}</span>
            </div>
            {this.props.secondLine && <div className={cn(st.secondLine, 'dvui-beard-second-line')}>
              {
                this.props.secondLine
              }
            </div>}
            {(this.props.thirdLine || this.props.contentBlock) &&
              <div className={st.extension}>
                {this.props.thirdLine &&
                  <div className={st.thirdLine}>{this.props.thirdLine}</div>
                }
                {this.props.contentBlock &&
                  <p className={st.contentBlock}>{this.props.contentBlock}</p>
                }
              </div>
            }
          </div>
          {this.props.actions &&
            <div className={st.actions}>
              {this.props.actions}
            </div>
          }
        </div>
      </div>
    )
  }
}
